import LithologyWrapper from '../../../../components/well-forms/lithology/lithology-wrapper'

export default function EditWellLithology() {
  return <LithologyWrapper isEditMode />
}
